import { Fragment } from 'react';
import { TextStyle } from 'react-native';
import { Text, TextProps } from '@ui-kitten/components';
import lodashFind from 'lodash/find';

export type HighlightTextProps = TextProps & {
  highlight: { word: string; style: TextStyle }[];
  text: string;
};
const escapeRegExp = (str: string) =>
  str?.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') ?? '';
const HighlightText = ({
  highlight = [],
  text = '',
  ...textProps
}: HighlightTextProps) => {
  const validHighlights = highlight.filter((h) => h.word);
  const escapedWords = validHighlights.map((h) => escapeRegExp(h.word));
  if (escapedWords.length === 0 || !text) {
    return <Text {...textProps}>{text}</Text>;
  }
  const regex = new RegExp(`(${escapedWords.join('|')})`, 'gi');
  const parts = text.split(regex);
  const result = parts.map((part, index) => {
    const match = lodashFind(
      validHighlights,
      (h) => part.toLowerCase() === h.word.toLowerCase(),
    );
    if (!match) return <Fragment key={index}>{part}</Fragment>;
    return (
      <Text key={index} {...textProps} style={[textProps.style, match.style]}>
        {match.word}
      </Text>
    );
  });
  return <Text {...textProps}>{result}</Text>;
};

export default HighlightText;
